import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { BulkOperationPipesModule } from '../../features/bulk-operation/pipes/bulk-operation-pipes.module'
import { DisplayDatePipeModule } from '../../shared/pipes/display-date.pipe.module'
import { SafeHtmlModule } from '../../shared/pipes/safe-html.module'
import { NotificationDetailDialogComponent } from './dialogs/notification-detail/notification-detail-dialog.component'
import { DirectivesUpgradedModule } from '../../shared/directives/directivesUpgraded.module'
import { NgClickOutsideDirective } from 'ng-click-outside2'
import { StoreModule } from '@ngrx/store'
import { StoreKeysEnum } from '../../store/store-keys'
import { mainViewReducer } from './state/main-view.reducers'
import { commandPaletteReducer } from './state/command-palette.reducers'
import { EffectsModule } from '@ngrx/effects'
import { MainViewEffects } from './state/main-view.effects'
import { MainViewActionsService } from './state/main-view-actions.service'
import { HeaderModule } from './header/header.module'
import { BulkOperationAnnouncementsModule } from './bulk-operation-announcements/bulk-operation-announcements.module'

@NgModule({
    imports: [
        BulkOperationPipesModule,
        BulkOperationAnnouncementsModule,
        DirectivesUpgradedModule,
        CommonModule,
        FormsModule,
        HeaderModule,
        DisplayDatePipeModule,
        SafeHtmlModule,
        NgClickOutsideDirective,
        StoreModule.forFeature(StoreKeysEnum.MainViewFeature, mainViewReducer),
        StoreModule.forFeature(StoreKeysEnum.CommandPalette, commandPaletteReducer),
        EffectsModule.forFeature([MainViewEffects]),
    ],
    declarations: [
        NotificationDetailDialogComponent,
    ],
    providers: [
        MainViewActionsService,
    ],
})
export class MainModule {}